<div class="progress-bar-container" *ngIf="progress > 0">
    <div class="progress">
      <div class="progress-bar" [style.width.%]="progress">{{progress}}%
      </div>
    </div>
  </div>